import React from 'react'
import { DescriptionList, Modal } from '@enamelai/design-system'
import type { FolderItem } from '../FilesAndLettersFolderGrid/FilesAndLettersFolderGrid.component'
import type { MockFileItem } from '@pages/Files/mockFilesData'
import { useAppSelector } from '@store/hooks'
import './FolderDetailsModal.css'

export type FolderDetailsModalProps = {
  show: boolean
  onHide: () => void
  folder: FolderItem | null
  files: MockFileItem[]
}

const FolderDetailsModal: React.FC<FolderDetailsModalProps> = ({
  show,
  onHide,
  folder,
  files,
}) => {
  const backendDetails = useAppSelector((state) => state.folder.folderDetails)

  if (!folder) return null

  const fileCount = backendDetails?.file_count ?? files.length
  const folderName = backendDetails?.folder_name ?? folder.name ?? '—'
  const isDefault = backendDetails?.folder_type
    ? backendDetails.folder_type === 'default'
    : folder.isDefault
  const fileList =
    backendDetails?.files?.map((file) => ({
      id: file.file_id,
      fileName: file.original_name || file.file_name,
      fileSize: `${(file.file_size / 1024 / 1024).toFixed(2)} MB`,
    })) ??
    files.map((file) => ({
      id: file.id,
      fileName: file.fileName,
      fileSize: file.fileSize,
    }))

  return (
    <Modal
      open={show}
      onClose={onHide}
      title="Folder details"
      primaryLabel=""
      secondaryLabel="Close"
      onSecondaryClick={onHide}
      bodyClassName="folder-details-modal-body"
    >
      <DescriptionList
        variant="file-details"
        columns={1}
        items={[
          { label: 'Name', value: folderName },
          {
            label: 'Type',
            value: isDefault ? 'Default folder' : 'Custom folder',
          },
          {
            label: 'Files',
            value: `${fileCount} ${fileCount === 1 ? 'file' : 'files'}`,
          },
        ]}
      />
      {fileCount > 0 && fileList.length > 0 && (
        <div className="folder-details-files-section">
          <span className="folder-details-files-label">File list</span>
          <ul className="folder-details-file-list">
            {fileList.map((file) => (
              <li key={file.id} className="folder-details-file-item">
                <span className="folder-details-file-name">
                  {file.fileName}
                </span>
                <span className="folder-details-file-size">
                  {file.fileSize}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </Modal>
  )
}

export default FolderDetailsModal
